import { createFileRoute } from '@tanstack/react-router';

import { BusinessManagementTab } from '../modules/ProjectDashboard/components/Tabs/BusinessManagementTab';

export const Route = createFileRoute('/businesses')({
  component: RouteComponent,
  head() {
    return {
      meta: [{ title: 'Businesses' }],
    };
  },
});

function RouteComponent() {
  return (
    <div className="container mx-auto max-w-2xl p-6">
      <h1 className="mb-6 text-2xl font-semibold">Business Management</h1>
      <BusinessManagementTab />
    </div>
  );
}
